<template>
   <div>
      <v-navigation-drawer
         :right="direction"
         width="10%"
         v-model="drawer"
         app
         color="secondary"
      >
      <div>
         <img
            height="70vh"
            width="100%"
            class="main-logo"
            :src="require('@/assets/images/_Logo.jpeg')"
         />
      </div>
     <v-list>
      <v-list-item class="justify-center">
         <v-tooltip color="secondary white--text" :left="direction" :right="!direction">
           <template v-slot:activator="{ on, attrs }">
               <v-btn
                  text
                  v-bind="attrs"
                  v-on="on"
                  to="/home"
               >
                <v-icon
                   class="darken3--text"
                   x-large
                >
                   mdi-home
                </v-icon>
                </v-btn>
             </template>
             <span class="apps-tooltip">{{$t("HOME")}}</span>
         </v-tooltip>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item class="justify-center">
         <v-tooltip
            color="secondary white--text"
            :left="direction"
            :right="!direction"
         >
            <template v-slot:activator="{ on, attrs }">
               <v-btn
                  text
                  v-bind="attrs"
                  v-on="on"
                  to="/home/profile"
               >
                <v-icon
                   class="darken3--text"
                   x-large
                >
                    mdi-account
                </v-icon>
                </v-btn>
             </template>
             <span class="apps-tooltip">{{$t("PROFILE")}}</span>
          </v-tooltip>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item class="justify-center">
         <v-tooltip color="secondary white--text" :left="direction" :right="!direction">
            <template v-slot:activator="{ on, attrs }">
               <v-btn
                  text
                  v-bind="attrs"
                  v-on="on"
                  to="/home/ApplicationData/ListApplications"
               >
                <v-icon
                   class="darken3--text"
                   x-large
                >
                    mdi-file-multiple-outline
                </v-icon>
                </v-btn>
             </template>
             <span class="apps-tooltip">{{$t("APPLICATIONS")}}</span>
          </v-tooltip>
      </v-list-item>
      <v-divider></v-divider>
     <v-list-item class="justify-center">
         <v-tooltip color="secondary white--text" :left="direction" :right="!direction">
            <template v-slot:activator="{ on, attrs }">
               <v-btn
                  text
                  v-bind="attrs"
                  v-on="on"
                  to="/home/ApplicationData/ReorderApplications"
               >
                <v-icon
                   class="darken3--text"
                   x-large
                >
                  mdi-swap-vertical-circle-outline
                </v-icon>
                </v-btn>
             </template>
             <span class="apps-tooltip">{{$t("REORDER_APPLICATIONS")}}</span>
          </v-tooltip>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item class="justify-center">
         <v-tooltip color="secondary white--text" :left="direction" :right="!direction">
            <template v-slot:activator="{ on, attrs }">
               <v-btn
                  text
                  v-bind="attrs"
                  v-on="on"
                  to="/home/ApplicationData/AddApplication"
               >
                <v-icon
                   class="darken3--text"
                   x-large
                >
                    mdi-file-plus-outline
                </v-icon>
                </v-btn>
             </template>
             <span class="apps-tooltip">{{$t("NEW_APPLICATION")}}</span>
          </v-tooltip>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item class="justify-center">
         <v-tooltip color="secondary white--text" :left="direction" :right="!direction">
            <template v-slot:activator="{ on, attrs }">
               <v-btn
                  text
                  v-bind="attrs"
                  v-on="on"
                  to="/notifications"
               >
                  <v-badge
                   v-if="notificationCount > 0"
                   :content="notificationCount"
                   color="primary"
                   overlap
                 >
                   <v-icon
                      class="darken3--text"
                      x-large
                   >
                       mdi-bell
                   </v-icon>
                </v-badge>
                <v-icon
                   class="darken3--text"
                   x-large
                   v-else
                >
                    mdi-bell
                </v-icon>
                </v-btn>
             </template>
             <span class="apps-tooltip">{{$t("NOTIFICATIONS")}}</span>
          </v-tooltip>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item class="justify-center">
         <v-tooltip color="secondary white--text" :left="direction" :right="!direction">
            <template v-slot:activator="{ on, attrs }">
               <v-btn
                  text
                  v-bind="attrs"
                  v-on="on"
               >
                <v-icon
                   class="darken3--text"
                   x-large
                >
                    mdi-email-outline
                </v-icon>
                </v-btn>
             </template>
             <span class="apps-tooltip">{{$t("INTERNAL_MAIL")}}</span>
          </v-tooltip>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item class="justify-center">
         <v-tooltip color="secondary white--text" :left="direction" :right="!direction">
            <template v-slot:activator="{ on, attrs }">
               <v-btn
                  text
                  v-bind="attrs"
                  v-on="on"
               >
                <v-icon
                   class="darken3--text"
                   x-large
                >
                    mdi-email-newsletter
                </v-icon>
                </v-btn>
             </template>
             <span class="apps-tooltip">{{$t("SUGGESTIONS")}}</span>
          </v-tooltip>
      </v-list-item>
     </v-list>
  </v-navigation-drawer>
  <v-app-bar
     :right="direction"
     color="white"
      app
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
<!--      <v-avatar size="70" v-show="$vuetify.breakpoint.mdAndUp">-->
<!--         <img :src="logo" />-->
<!--      </v-avatar>-->

    <v-img
                :src="miniLogo"
                max-width="70"
                contain
                class="mx-auto"
              />
      <v-toolbar-title v-show="$vuetify.breakpoint.mdAndUp">
         <span class="title">{{$t("SYSTEM_NAME")}}</span>
         <span class="headline"> {{serverTranslate(foundationName)}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-show="$vuetify.breakpoint.mdAndUp">
         <v-btn text class="primary--text h6" v-if="direction">
              {{$t("ACADEMIC_SEMESTER")}} {{serverTranslate(semester)}}
        </v-btn>
        <v-btn text class="primary--text h6" v-else>
             {{serverTranslate(semester)}} {{$t("ACADEMIC_SEMESTER")}}
       </v-btn>
         <v-divider
            vertical
            inset
          ></v-divider>
         <v-btn text class="primary--text h6">
            {{year}}
        </v-btn>
     </v-toolbar-items>
     <v-spacer></v-spacer>
     <ad-changeLanguage showTooltip="true" v-on:swichLanguage="onLanguageChanged" />
     <v-spacer></v-spacer>
     <v-menu
      >
       <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
          >
          <v-avatar>
             <img
              :src="profileImage || '/user_avatar.png'"
            >
          </v-avatar>
          </v-btn>
       </template>
       <v-list>
          <v-list-item>
             <v-list-item-title>
                {{username}}
             </v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/home/profile"
          >
            {{ $t("PROFILE") }}
            <v-icon class="primary--text">mdi-account</v-icon>
          </v-list-item>
          <v-list-item
            @click="logout"
          >
            {{ $t("LOGOUT") }}
            <v-icon class="primary--text">mdi-logout</v-icon>
          </v-list-item>
       </v-list>
      </v-menu>
    </v-app-bar>
   </div>
</template>
<script>
import ChangeLanguage from "@/components/layout/ChangeLanguage";
import serverTranslationsMixin from "@/mixins/serverTranslations.js";
export default {
   components: {
     "ad-changeLanguage": ChangeLanguage,
   },
   mixins: [serverTranslationsMixin],
   computed: {
     direction: function() {
       return this.$store.state.direction;
    },
    profileImage: function() {
       return this.$store.state.profileImage
    }
  },
   data() {
     return {
        drawer:true,
        foundationName:"",
        notificationCount:0,
        semester:"",
        year:"",
        username:"",
        logo:"",
        miniLogo:"",
        notifications:[]
     }
  },
  mounted() {
   this.homeData()
 },
  methods: {
    logout: function() {
      this.$store.commit("logout");
   },
   homeData() {
      this.$http.get("/api/users/home/")
      .then(
         res => {
            this.foundationName = res.data.data.foundation.name
            this.logo = res.data.data.foundation.logo
            this.miniLogo = res.data.data.foundation.miniLogo
            this.notificationCount = res.data.data.notifications.length
            this.notifications = res.data.data.notifications
            this.semester = res.data.data.semester.name
            localStorage.setItem("profileImage", res.data.data.user.profileImage);
            this.$store.commit("profileImage", res.data.data.user.profileImage);
            this.username = res.data.data.user.username
            this.year = res.data.data.year.name
            localStorage.setItem("academicYearID", res.data.data.year.id);
            localStorage.setItem("semesterID", res.data.data.semester.id);
            this.passNotifications()
         }
         ,err => {
            this.$toasted.show(
              this.serverTranslate(err.response.data.message),
              {
                type: "error",
                icon: "error_outline",
                theme: "bubble",
                position: "bottom-left",
                duration: 3000
              }
            );
         }
      )
   },
   passNotifications() {
      this.$emit('passNotifications', this.notifications)
    }
  }
};
</script>
